/*
  Custom JavaScript for Tribal Society - Velstar
*/

// TS-60: Custom Element for PDP Custom Options
class PDPCustomOption extends HTMLElement {
  constructor() {
    super();
    this.visibleInput = this.querySelector('[data-visible-input]');
    this.hiddenInput = this.querySelector('[data-hidden-input]');
    this.detailsElement = this.querySelector('[data-details]');
    this.detailsToggleButton = this.querySelector('[data-custom-option-toggle]');

    if (this.detailsToggleButton) {
      this.detailsToggleButton.addEventListener('click', () => {
          const isOpen = this.detailsElement.hasAttribute('open');
          if(isOpen) {
            this.detailsElement.removeAttribute('open');
            this.hiddenInput.value = '';
          } 
          else {
            this.detailsElement.setAttribute('open', '');
            this.updateHiddenInput();
          }
      });
    }
  }

  connectedCallback() {
    if (this.visibleInput && this.hiddenInput) {
      this.visibleInput.addEventListener('input', this.updateHiddenInput.bind(this));
      this.visibleInput.addEventListener('change', this.updateHiddenInput.bind(this));
    }
  }

  updateHiddenInput() {
    if (this.visibleInput && this.hiddenInput) {
      this.hiddenInput.value = this.visibleInput.value;
    }
  }
}

customElements.define('pdp-custom-option', PDPCustomOption);

// TS-71 Custom Video Carousel & Video Metafield Play Button
document.addEventListener("DOMContentLoaded", function() {
  const videoSlides = document.querySelectorAll(".videoSlide");

  videoSlides.forEach(slide => {
    const video = slide.querySelector("video");
    const btn = slide.querySelector("[data-play-pause-button]");

    btn.addEventListener("click", () => {
      if (video.paused) {
        video.play();
        btn.textContent = "⏸";
      } else {
        video.pause();
        btn.textContent = "▶"; 
      }
    });
  });
});
class CountdownBanner extends HTMLElement {
  constructor() {
    super();
    this.startDate = this.getAttribute('start-date');
    this.endDate = this.getAttribute('end-date');
    this.preCountdownText = this.getAttribute('pre-countdown-text') || '';
    this.countdownText = this.getAttribute('countdown-text') || '';

    this.interval = null;

    this.DAY = 1000 * 60 * 60 * 24;
    this.HOUR = 1000 * 60 * 60;
    this.MINUTE = 1000 * 60;
    this.SECOND = 1000;

    this.daysContainerEl = this.querySelector('[data-countdown-days-container]');
    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursContainerEl = this.querySelector('[data-countdown-hours-container]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.secondsEl = this.querySelector('[data-countdown-seconds]');
    this.messageEl = this.querySelector('[data-countdown-message]');

    this.init();
  }
  init() {
    if (!this.startDate || !this.endDate) {
      return this.classList.add('hidden');
    }
    this.startDate = new Date(this.startDate).getTime();
    this.endDate = new Date(this.endDate).getTime();
    if (isNaN(this.startDate) || isNaN(this.endDate)) {
      console.error('Invalid date');
      return this.classList.add('hidden');
    }

    this.interval = setInterval(() => this.updateCountdown(), this.SECOND);
    this.updateCountdown();
  }
  padNumber(num) {
    return num.toString().padStart(2, '0');
  }
  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    const days = Math.floor(distance / this.DAY);
    const hours = Math.floor((distance % this.DAY) / this.HOUR);
    const minutes = Math.floor((distance % this.HOUR) / this.MINUTE);
    const seconds = Math.floor((distance % this.MINUTE) / this.SECOND);

    if (minutes < 1) {
      clearInterval(this.interval);
      this.classList.add('hidden');
      return;
    }

    this.classList.remove('invisible', 'hidden');
    now < this.startDate ? this.messageEl.textContent = this.preCountdownText : this.messageEl.textContent = this.countdownText;

    days < 1 ? this.daysContainerEl.classList.add('hidden') : this.daysEl.textContent = this.padNumber(days);
    this.hoursEl.textContent = this.padNumber(hours);
    this.minutesEl.textContent = this.padNumber(minutes);
    this.secondsEl.textContent = this.padNumber(seconds);
  }
}

customElements.define('countdown-banner', CountdownBanner);

/* ===== Mobile PDP enhancements — appended 3 Nov 2026 ===== */
(function () {
  var TS_SATC_CSS =
    '.ts-satc{position:fixed;left:0;right:0;bottom:0;z-index:1000;display:none;align-items:center;gap:12px;padding:10px 14px calc(10px + env(safe-area-inset-bottom));background:#ffffff;border-top:1px solid #e6e6e6;box-shadow:0 -4px 18px rgba(0,0,0,.09);transform:translateY(130%);visibility:hidden;transition:transform .22s ease}'
  + 'body.ts-satc-on .ts-satc{transform:translateY(0);visibility:visible}'
  + '.ts-satc__info{flex:0 0 auto;line-height:1.25}'
  + '.ts-satc__price{display:block;font-size:15px;font-weight:700;color:#111111}'
  + '.ts-satc__size{display:block;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#8a8a8a}'
  + '.ts-satc__size--none{color:#c0392b}'
  + '.ts-satc__btn{flex:1 1 auto;height:48px;border:0;border-radius:6px;background:#111111;color:#ffffff;font-size:13px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;line-height:1;cursor:pointer}'
  + '.ts-satc__btn.is-muted{background:#9b9b9b}'
  + '.ts-satc-tray{position:fixed;left:0;right:0;bottom:69px;z-index:999;display:none;background:#ffffff;border-top:1px solid #e6e6e6;padding:14px 14px 0;transform:translateY(260px);visibility:hidden;transition:transform .24s ease}'
  + 'body.ts-satc-on.ts-satc-tray-on .ts-satc-tray{transform:translateY(0);visibility:visible}'
  + '.ts-satc-tray__lbl{display:block;font-size:10px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#8a8a8a;margin:0 0 10px}'
  + '.ts-satc-tray__row{display:flex;gap:8px;overflow-x:auto;padding-bottom:14px;scrollbar-width:none;-ms-overflow-style:none}'
  + '.ts-satc-tray__row::-webkit-scrollbar{display:none}'
  + '.ts-satc-sz{flex:0 0 auto;min-width:52px;height:44px;display:flex;align-items:center;justify-content:center;border:2px solid #111111;background:#ffffff;color:#111111;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}'
  + '.ts-satc-sz.is-on{background:#111111;color:#ffffff}'
  + '.ts-satc-sz.is-out{border-color:#e0e0e0;color:#c4c4c4;text-decoration:line-through;cursor:default}'
  + '@media screen and (max-width:749px){.ts-satc{display:flex}.ts-satc-tray{display:block}'
  + 'body.ts-satc-on shopify-chat{transform:translateY(-64px)}'
  + 'body.ts-satc-on.ts-satc-tray-on shopify-chat{transform:translateY(-168px)}'
  + '.template-product .swatch[data-option-index]:not(:has(img)){display:flex;flex-wrap:wrap;align-items:center;gap:5px;margin-bottom:6px !important}'
  + '.template-product .swatch[data-option-index]:not(:has(img))>label.header{flex:0 0 100%;width:100%;margin:0 0 3px !important}'
  + '.template-product .swatch[data-option-index]:not(:has(img)) .swatch-element{flex:1 1 0;min-width:32px;margin:0 !important}'
  + '.template-product .swatch[data-option-index]:not(:has(img)) .swatch-element .swatchLbl{display:flex;align-items:center;justify-content:center;width:100% !important;min-width:0 !important;padding:0 2px !important;height:38px;font-size:12px;letter-spacing:0;box-sizing:border-box}'
  + '.template-product .product-form{margin-bottom:6px !important}'
  + '.template-product .essential-upsell-cross-sell-block>div{padding-top:6px !important;padding-bottom:10px !important}'
  + '}';

  function init() {
    if (document.querySelector('.ts-satc')) return;

    if (!document.getElementById('ts-satc-style')) {
      var st = document.createElement('style');
      st.id = 'ts-satc-style';
      st.textContent = TS_SATC_CSS;
      document.head.appendChild(st);
    }

    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var realBtn = form.querySelector('.product-form__submit');
    if (!realBtn) return;

    var blocks = form.querySelectorAll('.swatch[data-option-index]');
    var swatch = blocks.length === 1 ? blocks[0] : null;
    var sizeEls = swatch ? Array.prototype.slice.call(swatch.querySelectorAll('.swatch-element')) : [];
    var useTray = sizeEls.length > 1;
    var priceEl = document.querySelector('[id^="ProductPrice-"]');

    var tray = document.createElement('div');
    tray.className = 'ts-satc-tray';
    tray.innerHTML = '<span class="ts-satc-tray__lbl">Select size</span><div class="ts-satc-tray__row"></div>';
    document.body.appendChild(tray);

    var bar = document.createElement('div');
    bar.className = 'ts-satc';
    bar.innerHTML = '<div class="ts-satc__info"><span class="ts-satc__price"></span><span class="ts-satc__size"></span></div>'
                  + '<button type="button" class="ts-satc__btn">Add to cart</button>';
    document.body.appendChild(bar);

    var row = tray.querySelector('.ts-satc-tray__row');
    var bP = bar.querySelector('.ts-satc__price');
    var bS = bar.querySelector('.ts-satc__size');
    var bB = bar.querySelector('.ts-satc__btn');

    if (useTray) {
      sizeEls.forEach(function (el) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ts-satc-sz';
        b.textContent = el.getAttribute('data-value') || '';
        b.tsSource = el;
        b.addEventListener('click', function () {
          if (el.classList.contains('soldout')) return;
          var l = el.querySelector('label.swatchLbl');
          if (l) l.click();
          document.body.classList.remove('ts-satc-tray-on');
          setTimeout(sync, 120);
        });
        row.appendChild(b);
      });
    }

    function lift() { tray.style.bottom = bar.offsetHeight + 'px'; }

    function chosen() {
      var c = form.querySelector('.swatch .slVariant');
      return c ? c.textContent.trim() : '';
    }

    function sync() {
      if (priceEl) bP.textContent = priceEl.textContent.trim();
      var t = chosen();
      if (!useTray) {
        bS.textContent = '';
        bS.classList.remove('ts-satc__size--none');
      } else if (t) {
        bS.textContent = 'Size ' + t;
        bS.classList.remove('ts-satc__size--none');
      } else {
        bS.textContent = 'Select size';
        bS.classList.add('ts-satc__size--none');
      }
      var sold = realBtn.disabled && t;
      bB.textContent = sold ? 'Sold out' : realBtn.textContent.trim();
      bB.classList.toggle('is-muted', !!sold);
      Array.prototype.forEach.call(row.querySelectorAll('.ts-satc-sz'), function (b) {
        b.classList.toggle('is-on', b.textContent === t);
        if (b.tsSource) {
          var out = b.tsSource.classList.contains('soldout');
          b.classList.toggle('is-out', out);
          b.disabled = out;
        }
      });
      lift();
    }

    function scrollToForm() {
      var target = blocks[0] || form;
      var go = function (smooth) {
        var y = target.getBoundingClientRect().top + window.pageYOffset - 140;
        window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
      };
      go(true);
      setTimeout(function () { go(false); }, 700);
      setTimeout(function () { go(false); }, 1400);
    }

    bB.addEventListener('click', function () {
      if (realBtn.disabled) {
        if (useTray) { document.body.classList.toggle('ts-satc-tray-on'); return; }
        if (blocks.length) scrollToForm();
        return;
      }
      document.body.classList.remove('ts-satc-tray-on');
      realBtn.click();
    });

    if (sizeEls.length === 1 && !sizeEls[0].classList.contains('soldout')) {
      setTimeout(function () {
        if (chosen()) return;
        var l = sizeEls[0].querySelector('label.swatchLbl');
        if (l) { l.click(); setTimeout(sync, 150); }
      }, 500);
    }

    function pos() {
      var show = window.pageYOffset > 250;
      if (!show) document.body.classList.remove('ts-satc-tray-on');
      document.body.classList.toggle('ts-satc-on', show);
    }

    window.addEventListener('scroll', pos, { passive: true });
    window.addEventListener('resize', function () { lift(); pos(); });
    document.addEventListener('change', sync, true);

    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      mo.observe(form, { subtree: true, childList: true, attributes: true, characterData: true });
      if (priceEl) mo.observe(priceEl, { subtree: true, childList: true, characterData: true });
    }

    sync();
    pos();
    setTimeout(sync, 600);
    setTimeout(sync, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== Free 3ml keyring picker (cart drawer) — appended 3 Nov 2026 =====
   Called by the scent buttons in snippets/ts-keyring-unlock.liquid.
   It lives here, not in that snippet, because the cart drawer is redrawn
   with innerHTML and inline <script> tags never re-execute.               */
window.tsAddKeyring = function (btn, variantId) {
  if (btn.dataset.busy) return;
  btn.dataset.busy = '1';
  btn.disabled = true;

  var drawer = document.querySelector('cart-drawer');
  var body = { items: [{ id: variantId, quantity: 1 }] };

  if (drawer && typeof drawer.getSectionsToRender === 'function') {
    body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    body.sections_url = window.location.pathname;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
    body: JSON.stringify(body)
  })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (res.status) { window.location.reload(); return; }
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.renderContents(res);
      } else {
        window.location.reload();
      }
    })
    .catch(function () { window.location.reload(); });
};
